import { qs } from '../qs'
import curd from '../curd'

const BASE_PATH = '/anti/control'

export default curd(BASE_PATH, {
  getControlLog: query => ({
    url: `${BASE_PATH}/list`,
    method: 'POST',
    data: query
  }),
  getPullData: query => ({
    url: `${BASE_PATH}/pull/data/${qs(query, '?')}`,
    method: 'GET'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/Anti.js